import React from 'react'

const ButtonRow = ({ children }) => (
  <div className="cookunity__button_row">{children}</div>
)

export default ButtonRow



// WEBPACK FOOTER //
// ./src/components/Form/ButtonRow.jsx